import {handleActions} from 'redux-actions';

import {
  ADD_COACH_TO_WATCHLIST,
  GET_COACH_WATCHLIST,
  REMOVE_COACH_FROM_WATCHLIST,
} from '/redux/action/myTeams.action';

interface WatchListState {
  downlineCoachIds: number[];
  count: number;
}

const initialState: WatchListState = {
  downlineCoachIds: [],
  count: 0,
};

export default handleActions<WatchListState, any>(
  {
    [GET_COACH_WATCHLIST]: (state, {payload}) => {
      const downlineCoachIds = payload?.downlineCoachIds ?? [];
      return {
        ...state,
        downlineCoachIds,
        count: payload?.count,
      };
    },

    [ADD_COACH_TO_WATCHLIST]: (state, {payload}) => {
      const newIds = [...new Set([...state.downlineCoachIds, payload])];
      return {
        ...state,
        downlineCoachIds: newIds,
        count: newIds.length,
      };
    },

    [REMOVE_COACH_FROM_WATCHLIST]: (state, {payload}) => {
      const newIds = state.downlineCoachIds.filter(id => id !== payload);
      return {
        ...state,
        downlineCoachIds: newIds,
        count: newIds.length,
      };
    },
  },
  initialState,
);
